import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { loading, profile } = useAuth();
  const location = useLocation();
  const [checkingService, setCheckingService] = useState(false);
  const [serviceOperable, setServiceOperable] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!profile || profile.role === 'platform_admin') {
        setServiceOperable(true);
        return;
      }

      try {
        setCheckingService(true);
        const { data, error } = await supabase.rpc('gym_service_snapshot', {
          target_gym_id: profile.gimnasioId || null,
        });

        if (error) {
          console.error('Error validando servicio SaaS:', error);
          setServiceOperable(true);
          return;
        }

        const row = Array.isArray(data) && data.length > 0 ? data[0] : null;
        setServiceOperable(Boolean(row?.operable));
      } finally {
        setCheckingService(false);
      }
    };

    check();
  }, [profile?.id, profile?.role, profile?.gimnasioId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!profile) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(profile.role)) {
    return <Navigate to="/" replace />;
  }

  if (checkingService) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (
    profile.role !== 'platform_admin' &&
    !serviceOperable &&
    !location.pathname.startsWith('/pagar-servicio')
  ) {
    return <Navigate to="/pagar-servicio" replace />;
  }

  return <>{children}</>;
}
